import { useQuery } from 'react-query'

// import { url, getCustomHeaders } from 'components/DataProvider/functions'
import { flow, isNil, reverse, sortBy } from 'lodash/fp'
// import axios, { type AxiosHeaders } from 'axios'
// import { assign } from 'lodash'
import { useDataProvider } from 'react-admin'
import {
  type SearchMemberBankAccountResponse,
  type AnnounceItem
} from '../../../../cdk/bapp/lib/lambda-api/src/types'

export const useGetAnnouncesUser = (): {
  isLoading: boolean
  data: AnnounceItem[]
} => {
  const dataProvider = useDataProvider()
  const { data, isLoading } = useQuery({
    queryKey: ['announcesUser'],
    queryFn: () => dataProvider['getAnnouncesUser'](),
    staleTime: isNil(process.env['NO_CACHE']) ? 3600 * 1000 : 0
  })
  return {
    isLoading,
    data: flow([sortBy<AnnounceItem>('date'), reverse])(data)
  }
}
export const useGetBankAccount = (
  id: string
): {
  isLoading: boolean
  data: ({ id: string } & SearchMemberBankAccountResponse) | undefined
} => {
  const dataProvider = useDataProvider()
  const { data, isLoading } = useQuery({
    queryKey: ['bankAccount', id],
    queryFn: async () => {
      if (isNil(id)) return undefined
      const { data } = await dataProvider
        .getOne<{ id: string } & SearchMemberBankAccountResponse>(
          'gmopg/bankaccount',
          {
            id
          }
        )
        .catch(() => ({ data: undefined }))
      return data
    }
  })
  return {
    isLoading,
    data
  }
}
